<div class="add-services-modal">
  <div class="modal-header">
    <h2>
      <svg width="42" height="38" viewBox="0 0 42 38">
        <g fill="transparent" fill-rule="evenodd" stroke="#0CC5D1" stroke-width="2">
          <path stroke-linecap="square" d="M5.455 19L5.455 35.364 34.545 35.364 34.545 19M5.455 0L0 9.09c-.006 2.525 1.726 4.722 4.182 5.306 2.456.583 4.99-.6 6.122-2.856.914 1.841 2.792 3.006 4.848 3.006S19.086 13.38 20 11.54c.914 1.841 2.792 3.006 4.848 3.006s3.934-1.165 4.848-3.006c1.131 2.257 3.666 3.44 6.122 2.856 2.456-.584 4.188-2.78 4.182-5.305L34.545 0H5.455z" transform="translate(1 1)" />
          <path d="M16.364 35.364L16.364 24.455 23.636 24.455 23.636 35.364" transform="translate(1 1)" />
        </g>
      </svg>

      <ng-container i18n="@@services.edit_service">Edit Services</ng-container>
    </h2>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="activeModal.dismiss()">
      <svg version="1.1" x="0px" y="0px" width="14" height="14" viewBox="0 0 14 14">
        <path class="icon-stroke" fill="none" stroke-width="2" stroke-linecap="square" d="M2.8,11.2l8.5-8.5 M2.8,2.8l8.5,8.5" />
      </svg>
    </button>
  </div>

  <div class="modal-body">
    <form [formGroup]="serviceForm" (ngSubmit)="submit()" class="add-product" #newServiceForm="ngForm">
      <div class="services-content" item-trigger="add-service">
        <fieldset class="id" [ngClass]="{ 'has-error': (isSubmitted || f.service_number.dirty) && f.service_number?.errors }">
          <label i18n="@@services.id">ID #</label>
          <input type="text" name="id" formControlName="service_number" placeholder="ID" />
          <span class="field-error" i18n="@@error.required" *ngIf="(isSubmitted || f.service_number.dirty) && f.service_number.errors?.required">Required</span>
          <span class="field-error" *ngIf="f.service_number.errors?.serverError">{{ f.service_number.errors?.serverError }}</span>
        </fieldset>

        <fieldset class="pr-name" [ngClass]="{ 'has-error': (isSubmitted || f.name.dirty) && f.name?.errors }">
          <label>
            <ng-container i18n="@@services.service_name">Service Name (English)</ng-container>
            <span class="required-star">*</span>
          </label>
          <!-- اسم الخدمة -->
          <input type="text" name="name" formControlName="name" maxlength="60" />
          <span class="field-error" i18n="@@error.required.service_name" *ngIf="(isSubmitted || f.name.dirty) && f.name.errors?.required">Service name is required</span>
          <span class="field-error" *ngIf="f.name.errors?.serverError">{{ f.name.errors?.serverError }}</span>
        </fieldset>

        <fieldset class="pr-name w-100">
          <label>
            <ng-container i18n="@@services.service_name">Service Name (Arabic)</ng-container>
          </label>
          <!-- اسم الخدمة -->
          <input type="text" name="name_ar" formControlName="name_ar" maxlength="60" />
        </fieldset>

        <div class="mixed-fieldset">
          <fieldset class="" [ngClass]="{ 'has-error': (isSubmitted || f.category_id.dirty) && f.category_id?.errors }">
            <label>
              <ng-container i18n="@@services.service_category">Service Category</ng-container>
              <span class="required-star">*</span>
            </label>

            <select
            app-select2
            [options]="{
              ajax: {url: serviceCategoriesApi},
              idColumn: 'id',
              textColumn: 'name',
              dropdownParent: 'form.add-product',
              lazyLoad: false
            }"
            [selected]="serviceInfo ? {id: serviceInfo.category_id, text: serviceInfo.category} : null"
            i18n-placeholder="@@services.type_category_name" placeholder="Type or Select Category Name"
            name="category_id"
            formControlName="category_id"
            [showAddNewItem]="'true'"
						[addNewItemTitle]="addNewCategoryTitle"
            (itemSelected)="onChangeClient($event)"
           ><option></option></select>
           <span class="field-error" i18n="@@error.required.category" *ngIf="(isSubmitted || f.category_id.dirty) && f.category_id.errors?.required">Category is required</span>
           <span class="field-error" *ngIf="f.category_id.errors?.serverError">{{ f.category_id.errors?.serverError }}</span>
          </fieldset>

          <fieldset class="oneThird" [ngClass]="{ 'has-error': (isSubmitted || f.quantity.dirty) && f.quantity?.errors }">
            <label>
              <ng-container i18n="@@products.available_qty">Available Qty</ng-container>
              <span class="required-star">*</span>
            </label>
            <input type="number" appPreventScroll name="available-qty" formControlName="quantity" />
            <span class="field-error" i18n="@@error.required" *ngIf="(isSubmitted || f.quantity.dirty) && f.quantity.errors?.required">Required</span>
            <span class="field-error" i18n="@@error.invalid_number" *ngIf="(isSubmitted || f.quantity.dirty) && f.quantity.errors?.min">Invalid</span>
            <span class="field-error" *ngIf="f.quantity.errors?.serverError">{{ f.quantity.errors?.serverError }}</span>
          </fieldset>

          <fieldset class="price twoThird" [ngClass]="{ 'has-error': (isSubmitted || f.price.dirty) && f.price?.errors }">
            <label>
              <ng-container i18n="@@services.price">Price</ng-container>
              <span class="required-star">*</span>
            </label>
            <!-- السعر -->
            <div class="tag-input">
              <input type="text" name="price" formControlName="price" />
              <span [innerHtml]="basicInfo?.currency_symbol"></span> 
            </div>
            <span class="field-error" i18n="@@error.required.price" *ngIf="(isSubmitted || f.price.dirty) && f.price.errors?.required">Price is required</span>
            <span class="field-error" i18n="@@error.invalid_number" *ngIf="(isSubmitted || f.price.dirty) && f.price.errors?.min">Invalid</span>
            <span class="field-error" *ngIf="f.price.errors?.serverError">{{ f.price.errors?.serverError }}</span>
          </fieldset>

          <fieldset class="oneThird" [ngClass]="{ 'has-error': (isSubmitted || f.discount_percent.dirty) && f.discount_percent?.errors }">
            <label i18n="@@services.discount">Discount</label>
            <div class="tag-input">
              <input type="number" appPreventScroll name="discount" formControlName="discount_percent"/>
              <span>%</span>
            </div>
            <span class="field-error" *ngIf="(isSubmitted || f.discount_percent.dirty) && f.discount_percent.errors">Invalid</span>
            <span class="field-error" *ngIf="f.discount_percent.errors?.serverError">{{ f.discount_percent.errors?.serverError }}</span>
          </fieldset>

          <fieldset class="twoThird">
            <label i18n="@@services.final_price">Final Price</label>
            <div class="tag-input">
              <input type="number" appPreventScroll name="final-price" formControlName="net_price" value="{{ amount }}" />
              <span [innerHtml]="basicInfo?.currency_symbol"></span> 
            </div>
          </fieldset>
        </div>

        <fieldset class="logo-uploder">
          <label i18n="@@products.image">Image</label>
          <file-pond #logoFile
            [options]="pondOptions"
            [files]="serviceImageUrl"
            (oninit)="pondHandleInit()"
            (onaddfile)="pondHandleAddFile($event)"
            (onprocessfileabort)="pondHandleRemoveFile($event)"
            >
          </file-pond>
          <!-- <input type="file" id="product-image" accept="image/*" class="d-none" (change)="onServiceImageChange($event, imageFileInput)" #imageFileInput/> -->
        </fieldset>

        <div class="input-group micronutrients_container">
          <div class="d-flex align-items-center gap-2 mb-3 w-100 justify-content-between">
            Addons
            <svg (click)="addAddon()" class="addOns" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M18 12.998H13V17.998C13 18.2633 12.8946 18.5176 12.7071 18.7052C12.5196 18.8927 12.2652 18.998 12 18.998C11.7348 18.998 11.4804 18.8927 11.2929 18.7052C11.1054 18.5176 11 18.2633 11 17.998V12.998H6C5.73478 12.998 5.48043 12.8927 5.29289 12.7052C5.10536 12.5176 5 12.2633 5 11.998C5 11.7328 5.10536 11.4785 5.29289 11.2909C5.48043 11.1034 5.73478 10.998 6 10.998H11V5.99805C11 5.73283 11.1054 5.47848 11.2929 5.29094C11.4804 5.1034 11.7348 4.99805 12 4.99805C12.2652 4.99805 12.5196 5.1034 12.7071 5.29094C12.8946 5.47848 13 5.73283 13 5.99805V10.998H18C18.2652 10.998 18.5196 11.1034 18.7071 11.2909C18.8946 11.4785 19 11.7328 19 11.998C19 12.2633 18.8946 12.5176 18.7071 12.7052C18.5196 12.8927 18.2652 12.998 18 12.998Z" fill="#EB1461"/>
            </svg>
          </div>

          <ng-container formArrayName="add_ons">
            <div class="addOns_block" *ngFor="let addon of addons.controls; let i = index" [formGroupName]="i">
              <div class="product-name position-relative">
                <label for="product-quantity">Name</label>
                <input type="text" id="product-name" formControlName="name">
              </div>
              <div class="product-name position-relative">
                <label for="product-quantity">Name (Arabic)</label>
                <input type="text" formControlName="name_ar">
              </div>
              <div class="product-price position-relative">
                <label for="product-quantity">Price</label>
                <input type="text" id="product-price" formControlName="price">
              </div>
              <svg (click)="removeAddon(i)" class="deleteOns" xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                <path d="M16 6.5V5.7C16 4.5799 16 4.01984 15.782 3.59202C15.5903 3.21569 15.2843 2.90973 14.908 2.71799C14.4802 2.5 13.9201 2.5 12.8 2.5H11.2C10.0799 2.5 9.51984 2.5 9.09202 2.71799C8.71569 2.90973 8.40973 3.21569 8.21799 3.59202C8 4.01984 8 4.5799 8 5.7V6.5M3 6.5H21M19 6.5V17.7C19 19.3802 19 20.2202 18.673 20.862C18.3854 21.4265 17.9265 21.8854 17.362 22.173C16.7202 22.5 15.8802 22.5 14.2 22.5H9.8C8.11984 22.5 7.27976 22.5 6.63803 22.173C6.07354 21.8854 5.6146 21.4265 5.32698 20.862C5 20.2202 5 19.3802 5 17.7V6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </div>
          </ng-container>
        </div>

        <fieldset>
          <label i18n="@@services.description">Description</label>
          <textarea placeholder="" formControlName="description"></textarea>
        </fieldset>
        <fieldset>
          <label i18n="@@services.description_ar">Description (Arabic)</label>
          <textarea placeholder="" formControlName="description_ar"></textarea>
        </fieldset>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button type="button" class="tu-btn pink" (click)="submitted=true;newServiceForm.ngSubmit.emit()">
      <span i18n="@@services.update">Update</span> <!-- إضافة -->
    </button>
  </div>
</div>
